<template>
  <div class="pb-3">
    <div class="row">
      <!-- <div class="col-6">
            <div class="icon shadow card bg-primary ">
               <div class="card">
              <div class="card-body bg-primary header-card">
                  <a class="text-white text-center text-icon" href="/sensor/chart" style="text-decoration:none;"><i class="fa fa-line-chart"></i></a>
              </div>
            </div>
          </div>
      </div>-->

      <!-- <div class="col-6">
            <div class="icon shadow bg-success ">
            <div class="card">
              <div class="card-body bg-success">
                <small class="text-white">Titik Pengamatan</small>
                 <a class="text-white " href="" style="text-decoration:none"><p>{{jumlahsensor}}</p></a>
              </div>
            </div>
            </div>
          </div>

           <div class="col-6">
            <div class="icon shadow bg-success ">
            <div class="card">
              <div class="card-body bg-warning">
                <small class="text-white">Data tersimpan</small>
                 <a class="text-white " href="" style="text-decoration:none"><p>{{this.$store.state.AllDevice.length | numFormat}}</p></a>
              </div>
            </div>
            </div>
      </div>-->
    </div>

    <div class="p-4">
      <input
        v-model="search"
        type="text"
        class="form-control"
        placeholder="Filter ..."
      />
    </div>
    <div class="card-body overflow-auto">
      <div class="table-responsive-lg shadow">
        <!-- <h2>Data terkini</h2> -->

        <table class="table">
          <thead>
            <!-- <tr>
      <th class="text-white text-center bg-success" colspan="4">DATA TERKINI</th>
            </tr>-->

            <tr>
              <th width="25%" scope="col">Lokasi Sensor</th>
              <th width="25%">Tanggal dan Jam</th>
              <th width="15%">Battery</th>
              <th width="auto" colspan="2">Ketinggian Air</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="x in searchList" :key="x._id">
              <th  scope="row">{{ x.appname }}</th>
              <td >{{ x.update_on | formatDate }}</td>
              <td >{{ x.batt }} volt</td>
              <td >
                {{ x.level }} meter
                <div class="progress mb-4">
                  <div
                    class="progress-bar"
                    :class="level(x.level)"
                    role="progressbar"
                    :style="{ width: x.level * 10 + '%' }"
                    aria-valuenow="20"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DataSensor",
  data() {
    return {
      // alldata:this.$store.state.AllDevice
    };
  },

  computed: {
    // AllApplication() {
    //     return this.$store.getters.AllApplication
    // },

    // jumlahsensor() {
    //     return this.$store.getters.AllApplication.length
    // },

    AllDevice() {
      return this.$store.state.AllDevice.slice(0, 100);
    },

    searchList() {
      return this.AllDevice.filter((x) => {
        return x.appname.toLowerCase().includes(this.search.toLowerCase());
      });
    },

    search: {
      get() {
        return this.$store.state.Search;
      },
      set(value) {
        this.$store.commit("set_Search", value);
      },
    },
  },
  methods: {
    level: function(value) {
      return {
        "bg-success": value <= 1.8,
        "bg-warning": value >= 1.81 && value <= 2.99,
        "bg-danger": value >= 3,
      };
    },
  },
};
</script>

<style scoped>
.card-body {
  max-height: 40vh;
  padding: 0px !important;
}

.icon {
  margin-top: 20px;
  /* padding:20px; */
  font-size: 30px;
  text-align: center;
  background-color: aqua;
}

.header-card {
  height: 105px;
}

.text-icon {
  margin-top: 20px;
  font-size: 64px;
}
</style>
